import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input()
  showSmall = false;

  @Input()
  text = '';

  constructor() {}

  ngOnInit() {}
}
